import { render } from "./worldSyncProductImportExcel.vue?vue&type=template&id=4a8e8971"
import script from "./worldSyncProductImportExcel.vue?vue&type=script&lang=js"
export * from "./worldSyncProductImportExcel.vue?vue&type=script&lang=js"

import "./worldSyncProductImportExcel.vue?vue&type=style&index=0&id=4a8e8971&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__